import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'
import { APP_SETTINGS_EMAIL_VERIFICATION_BYPASS_KEY, APP_SETTINGS_QUERY_KEY } from '@/config/appSettingsKeys'

/**
 * Global feature flag: when true, newly registered users are auto-confirmed (bypass email verification).
 * Stored in app_settings; toggled in Admin → Feature flags.
 */
export function useEmailVerificationBypassFlag() {
  const { data: value, isLoading } = useQuery({
    queryKey: [...APP_SETTINGS_QUERY_KEY, APP_SETTINGS_EMAIL_VERIFICATION_BYPASS_KEY],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('app_settings')
        .select('value')
        .eq('key', APP_SETTINGS_EMAIL_VERIFICATION_BYPASS_KEY)
        .maybeSingle()
      if (error) return false
      return data?.value === 'true'
    },
    staleTime: 60_000,
  })
  return { emailVerificationBypass: value ?? false, isLoading }
}
